import identity from 'lodash/identity';

const JSONParser = <T>(value: string): T | string => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

const JSONStringifier = <T>(value: T): string => JSON.stringify(value);

const get = <T>(name: string, useJSON = true): T | string | null => {
  const parse = useJSON ? JSONParser : identity;

  const item = localStorage.getItem(name);

  if (item !== null) {
    return parse<T>(item);
  }

  return item;
};

const set = <T>(name: string, value: T, useJSON = true) => {
  const stringify = useJSON ? JSONStringifier : identity;

  return localStorage.setItem(name, stringify(value) as string);
};

const remove = (name: string) => localStorage.removeItem(name);

export default {
  get,
  set,
  remove,
};
